<template>
    <div class="finance-page main-wrapper">
        <div class="finance-page__inner px-2 px-md-3 pt-2">
            <h3 class="finance-page__title">
                {{ $t('withdraw.withdraw_form') }}
            </h3>
            <div class="finance-alert" v-if="error">
                <span class="mx-auto">{{ typeof error === 'string' ? error : (error && error.message) || '' }}</span>
            </div>
            <div class="finance-panel">
                    <form class="mt-0">
                      <div class="finance-account-card my-2 text-center">
                          <img
                            class="finance-account-card__settings"
                            src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dc500777-e8e3-4267-ace1-cdcf5a215600/public"
                            alt=""
                            role="button"
                            tabindex="0"
                            @click="$router.push('/banking')"
                            @keyup.enter="$router.push('/banking')"
                          >
                          <div class="finance-account-card__head text-white text-center">{{ bankInfo.type }}</div>
                          <div class="finance-account-card__sub text-white text-center">{{ bankInfo.name }}</div>
                          <h3 class="finance-account-card__number">{{ blurLastFiveCharacters(bankInfo.account_number) }}</h3>
                      </div>

                        <!-- <div class="col-lg-12 mt-4 px-0 mx-0">
                              <label class="form-control-label" style="color: #000 !important; font-size: 1rem; font-weight: 400 !important;">{{$t('withdraw.current_turnover')}}  -  </label>
                              <span class="text-dark text-md" style="font-size: 1.1rem; font-weight: 400 !important;"> {{ Number($store.state.authUser.total_bet_amount).toLocaleString() }}</span> <br>

                              <label class="form-control-label" style="color: #000 !important; font-size: 1rem; font-weight: 400 !important;">{{$t('withdraw.available_withdrawal_amount')}}  -  </label>
                              <span style="font-size: 1.1rem; font-weight: 400 !important; color: #00f23d" class="text-md" v-if="($store.state.authUser.total_bet_amount - $store.state.authUser.all_withdraw) > 0"> {{ Number($store.state.authUser.total_bet_amount - $store.state.authUser.all_withdraw).toLocaleString() }}</span>
                              <span style="font-size: 1.1rem; font-weight: 400 !important; color: #00f23d" class="text-md" v-else> 0</span>
                              
                              <div class="col-12 px-0 mx-0">
                                  <span style="color: #343434;font-size: 0.8rem; font-weight: 400 !important;">
                                    စုစုပေါင်း Turn Over ( ကစားအား ) သည် ထုတ်လိုသောငွေ၏ အနည်းဆုံး တစ်ဆ အထက်ရှိရမည်။ ဥပမာ - ငွေ တစ်သိန်း ထုတ်လိုပါက Turn Over ( ကစားအား ) တစ်သိန်းအထက်ရှိရမည် ဖြစ်သည်။
                                  </span>
                              </div>
                        </div> -->
                          
                        <div class="pt-3">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label class="finance-label" for="withdraw-amount">{{ $t('withdraw.amount') }}</label>
                                        <span class="finance-hint d-block mb-1">{{ $t('withdraw.minimum_deposit') }}</span>
                                        <input
                                            type="number"
                                            id="withdraw-amount"
                                            class="form-control finance-input"
                                            v-model="withdrawData.amount"
                                        >
                                        <span class="text-danger small d-block mt-1">{{
                                            errors.amount
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label class="finance-label" for="withdraw-remark">{{ $t('withdraw.remark') }}</label>
                                <textarea
                                    id="withdraw-remark"
                                    rows="4"
                                    class="form-control finance-input finance-textarea"
                                    v-model="withdrawData.remark"
                                />
                            </div>
                            <div class="form-group mb-0">
                                <button
                                    type="button"
                                    class="btn finance-btn-primary"
                                    @click="isConfirm ? '' : sendWithdrawData()"
                                >
                                    <div v-if="!isConfirm">
                                        {{ $t('withdraw.submit') }}
                                    </div>
                                    <Loading
                                        color="#ffffff"
                                        v-if="isConfirm"
                                        size="24"
                                        class="px-4 py-0"
                                    />
                                </button>
                            </div>
                        </div>
                    </form>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      imageUploader: [],
      selected_account: {
        account_id: null,
      },
      bankInfo: {},
      accounts: [
        {
          name: 'KBZ pay',
          id: 'KBZ pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kpay.png',
        },
        {
          name: 'KBZ pay',
          id: 'KBZ pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kpay.png',
        },
        {
          name: 'KBZ Mobile Banking',
          id: 'KBZ Mobile Banking',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kbz.png',
        },
        {
          name: 'Wave pay',
          id: 'Wave pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/wavepay.png',
        },
        {
          name: 'CB Pay',
          id: 'CB Pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/cb_pay.png',
        },
        {
          name: 'CB Banking',
          id: 'CB Banking',
          link: 'https://cdn.gold549.com/build/assets/img/payments/cbbank.png',
        },
        {
          name: 'AYA Pay',
          id: 'AYA Pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/ayapay.png',
        },
        {
          name: 'AYA Banking',
          id: 'AYA Banking',
          link: 'https://cdn.gold549.com/build/assets/img/payments/aya.png',
        },

      ],
      account: [],
      imageUploader: [],
      withdrawData: {},
      errors: {},
      isConfirm: false,
    };
  },
  methods: {
    blurLastFiveCharacters(inputString = "0000000000") {
    // Get the length of the input string
    const length = inputString.length;

    // Check if the input string has at least five characters
    if (length >= 7) {
      // Extract the first part of the string
      const firstPart = inputString.substring(length - 5, length);

      // Create a string with '*' characters for the last five numbers
      const blurredCharacters = '*'.repeat(length-5);

      // Concatenate the first part and the blurred numbers
      const blurredString = blurredCharacters + firstPart;

      return blurredString;
    } else {
      // Return the input string unchanged if it has less than five characters
      return inputString;
    }
  },
    ...mapActions(['fetchUser']),
    async sendWithdrawData() {
      try {
        this.isConfirm = true;
        const authUser = await this.fetchUser();
        this.errors = {};
        // if ((this.$store.state.authUser.total_bet_amount - this.$store.state.authUser.all_withdraw) < this.withdrawData.amount) {
        //   this.errors.amount = this.$store.state.language === 'en'
        //     ? 'Withdrawal amount should be greater than Turn Over Amount'
        //     : 'ထုတ်ယူသည့်ပမာဏသည် Turn Over Amount ထက် ပိုများနေရပါမည်။';
        //     this.isConfirm = false;
        //   return false;
        // }
        if (!this.withdrawData.amount) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter amount'
            : 'ငွေပမာဏထည့်ပေးပါ။';
  this.isConfirm = false;          
            return false;
        }
        if (this.withdrawData.amount < 10000) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter at least 10000 MMK'
            : 'ငွေပမာဏအနည်းဆုံး ၁၀၀၀၀ ထည့်ပေးပါ။';
  this.isConfirm = false;          
            return false;
        }
        if (this.withdrawData.amount > parseInt(authUser.amount)) {
          const balanceError = this.$store.state.language === 'en'
            ? "You Don't Have Sufficient Balance"
            : 'အကောင့်ထဲတွင် ပိုက်ဆံအလုံအလောက် မရှိပါ။';
          Dialog.alert({
            message: balanceError,
            confirmButtonText:
                            this.$store.state.language === 'en'
                              ? 'Go Back'
                              : 'နောက်သို့ပြန်သွားမည်။',
          }).then(() => {
            // on close
          });
          this.isConfirm = false;
          return false;
        }
        this.$store.commit(
          'setAmount',
          (this.$store.state.amount -= this.withdrawData.amount),
        );
        
        if (this.imageUploader[0]) {
          this.withdrawData.transaction_image = this.imageUploader[0].content;
        }
        // this.withdrawData.type = this.selected_account.account_id;
        this.withdrawData.date = this.currentTime;
        this.withdrawData.account_number = this.bankInfo.account_number;
        this.withdrawData.account_name = this.bankInfo.name;
        this.withdrawData.type = this.bankInfo.type;
        this.withdrawData.lang = localStorage.getItem("language");

        const res = await axios.post('/withdraws', this.withdrawData, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  },
              });
        const resUser = await axios.post(
          `/admin/user/${this.$store.state.authUser.id}`,
          {
            amount: this.withdrawData.amount,
            type: 'withdraw',
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
          }
        );
        this.imageUploader = [];
        this.withdrawData = {};
        this.selected_account.account_id = null;
        await this.fetchUser();
        Toast.success('Success');
        this.isConfirm = false;
      } catch (error) {
        Toast.fail('Fail');
        this.error = error.response.data
        this.isConfirm = false;
      }
      return true;
    },
    createDateWithTimeZone() {
      const moment = require('moment-timezone');
      const dateInTimeZone = moment.tz(new Date(), 'Asia/Rangoon');
      // Extract individual components from moment object
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();

      // Create a new Date object with the extracted components
      const newDateObject = new Date(year, month, day, hour, minute, second, millisecond);
      return newDateObject;
    },
  },
  //   watch: {
  //     'selected_account.account_id': function () {
  //       this.account = this.accounts.filter(
  //         (account) => account.id === this.selected_account.account_id,
  //       );
  //     },
  //   },
  computed: {
    currentTime() {
      return moment(this.createDateWithTimeZone()).format('lll');
    },
  },
  async mounted() {
    // this.$store.commit('setLoading', true);
    const authUser = await this.fetchUser();
    // this.$store.commit('setLoading', false);
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if(authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
    if(authUser && (!authUser.bank.account_number || !authUser.bank.name)){
      this.$router.push('/banking')
    }
    this.bankInfo = authUser.bank;
  },
};
</script>
<style scoped>
.image-container {
    width: 200px;
    height: 200px;
}
.image-container img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
}
.number-container {
    border-radius: 5px;
    background: #e9ecef;
    justify-content: center;
}
.custom-file {
    height: auto;
}
</style>
